import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M17 15h2v2h-2zm0-4h2v2h-2zm0-4h2v2h-2zm-3.26 0 1.26.84V7z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M10 3v1.51l2 1.33V5h9v14h-4v2h6V3z"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M8.17 5.7 15 10.25V21H1V10.48L8.17 5.7zM10 19h3v-7.84L8.17 8.09 3 11.38V19h3v-6h4v6z"
}, "2"), /*#__PURE__*/_jsx("path", {
  d: "M10 19h3v-7.84L8.17 8.09 3 11.38V19h3v-6h4z",
  opacity: ".3"
}, "3")], 'HomeWorkTwoTone');